import React from "react";
import { images } from "../../../assets";
import { AppLogoIcon } from "../../Icons";
import {
  AuthLayoutContainer,
  AuthLeftPanel,
  AuthRightPanel,
  AuthLogoContainer,
  AuthContentContainer,
} from "./AuthLayout.styled";

type AuthLayoutProps = {
  children: React.ReactNode;
};

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <AuthLayoutContainer>
      <AuthLeftPanel>
        <AuthLogoContainer>
          <AppLogoIcon />
        </AuthLogoContainer>

        <AuthContentContainer>{children}</AuthContentContainer>
      </AuthLeftPanel>

      <AuthRightPanel backgroundImage={images.loginBg} />
    </AuthLayoutContainer>
  );
};

export default AuthLayout;
